import { css, makeStyles } from '@conexasaude/conexa-hero'

export const useStyles = makeStyles({
  inbox: theme => css`
    margin-top: ${theme.spacing.xs};
    height: calc(100dvh - 110px);
    width: 100%;
  `,
})
